'use strict';

module.exports = function (ngModule) {
    ngModule.directive('makePieChart', require('./makepiechart'));
}


/** WEBPACK FOOTER **
 ** ./src/pages/directives/piechart/index.js
 **/